import {BrowserRouter, Routes, Route} from "react-router-dom";
import DocumentMeta from 'react-document-meta';
import {META} from "./meta";
import Layout from "./Layout";
import Header from "./Header";
import Footer from "./Footer";
import Home from "./Home";
import NaturalResources from "./NaturalResources";
import Exhibitions from "./Exhibitions";
import Sport from "./Sport";
import Culture from "./Culture";
import TypesOfTourism from "./TypesOfTourism";
import AutoMotoTourism from "./TypeOfTourism/AutoMotoTourism";
import CyclingTourism from "./TypeOfTourism/CyclingTourism";
import DomesticTourism from "./TypeOfTourism/DomesticTourism";
import WaterTourism from "./TypeOfTourism/WaterTourism";
import InboundTourism from "./TypeOfTourism/InboundTourism";
import OutboundTourism from "./TypeOfTourism/OutboundTourism";
import BusinessTourism from "./TypeOfTourism/BusinessTourism";
import DisabledTourism from "./TypeOfTourism/DisabledTourism";
import CommercialTourism from "./TypeOfTourism/CommercialTourism";
import EquestrianTourism from "./TypeOfTourism/EquestrianTourism";
import CulturalTourism from "./TypeOfTourism/CulturalTourism";
import MedicalTourism from "./TypeOfTourism/MedicalTourism";
import SkiTourism from "./TypeOfTourism/SkiTourism";
import YouthTourism from "./TypeOfTourism/YouthTourism";
import MuseumTourism from "./TypeOfTourism/MuseumTourism";
import ScientificTourism from "./TypeOfTourism/ScientificTourism";
import NostalgicTourism from "./TypeOfTourism/NostalgicTourism";
import HuntingTourism from "./TypeOfTourism/HuntingTourism";
import PilgrimageTourism from "./TypeOfTourism/PilgrimageTourism";
import Hiking from "./TypeOfTourism/Hiking";
import BorderTourism from "./TypeOfTourism/BorderTourism";
import AdventureTourism from "./TypeOfTourism/AdventureTourism";
import RecreationalTourism from "./TypeOfTourism/RecreationalTourism";
import AmateurTourism from "./TypeOfTourism/AmateurTourism";
import WeddingTourism from "./TypeOfTourism/WeddingTourism";
import RuralTourism from "./TypeOfTourism/RuralTourism";
import SportsTourism from "./TypeOfTourism/SportsTourism";
import Ecotourism from "./TypeOfTourism/Ecotourism";
import VirtualTours from "./VirtualTours";
import BeloeOzero from "./VirtualTours/BeloeOzero";
import MulnoieOzero from "./VirtualTours/MulnoieOzero";
import BelPuscha from "./VirtualTours/BelPuscha";
import MuseumLocomotive from "./VirtualTours/MuseumLocomotive";
import MelittisSarmatica from './Topics/MelittisSarmatica';
import Hedera from './Topics/Hedera';
import NashaNiwaBelPuscha from './Topics/NashaNiwaBelPuscha';
import LocomotiveEU699_45 from './Topics/LocomotiveEU699_45';
import LocomotiveER770_36 from './Topics/LocomotiveER770_36';
import LocomotiveER17_750_01 from './Topics/LocomotiveER17_750_01';
import LocomotiveTE8026 from "./Topics/LocomotiveTE8026";
import LocomotiveTE074 from "./Topics/LocomotiveTE074";
import LocomotiveTE2596 from "./Topics/LocomotiveTE2596";
import LocomotiveTE5806 from "./Topics/LocomotiveTE5806";
import LocomotiveCO17_3268 from "./Topics/LocomotiveCO17_3268";
import LocomotiveL0009 from "./Topics/LocomotiveL0009";
import LocomotiveL1259 from "./Topics/LocomotiveL1259";
import LocomotiveTank9P from "./Topics/LocomotiveTank9P";
import LocomotiveTE1_20_165 from "./Topics/LocomotiveTE1_20_165";
import LocomotiveTEP60_0121 from "./Topics/LocomotiveTEP60_0121";
import LocomotiveCME2_209 from "./Topics/LocomotiveCME2_209";
import LocomotiveTEZ_6965 from "./Topics/LocomotiveTEZ_6965";
import LocomotiveTEM15_017 from "./Topics/LocomotiveTEM15_017";
import Locomotive2TEM109_002 from "./Topics/Locomotive2TEM109_002";
import LocomotiveM62_1003 from "./Topics/LocomotiveM62_1003";
import LocomotiveCranes from "./Topics/LocomotiveCranes";
import Wagons from "./Topics/Wagons";
import Platform from "./Topics/Platform";
import Cisterns from "./Topics/Cisterns";
import LelikovoKort from "./VirtualTours/LelikovoKort";
import LandOfKosciuszko from "./VirtualTours/LandOfKosciuszko";
import BronnayaMountain from "./VirtualTours/BronnayaMountain";
import AndreyTadeuszKosciuszko from "./VirtualTours/AndreyTadeuszKosciuszko";
import KosciuszkoMemorialSign from "./VirtualTours/KosciuszkoMemorialSign";
import KosciuszkoOpeningHouse from "./VirtualTours/KosciuszkoOpeningHouse";
import ShortBiography from "./VirtualTours/ShortBiography";
import BenzyarukPedigreeOfTheKostyushkasOfSiakhnowitz from "./VirtualTours/BenzyarukPedigreeOfTheKostyushkasOfSiakhnowitz";
import NestsyarchukHouseEstateOfTadeuszKosciuszko from "./VirtualTours/NestsyarchukHouseEstateOfTadeuszKosciuszko";
import BenzyarukTadeuszKosciuszko from "./VirtualTours/BenzyarukTadeuszKosciuszko";
import BenzyarukBirthOfKosciuszko from "./VirtualTours/BenzyarukBirthOfKosciuszko";
import Events from "./Events";
import OpeningBegin from "./Events/OpeningBegin";
import BrestchinaRelax2006 from "./Events/BrestchinaRelax2006";
import ReferenceInformation from "./ReferenceInformation";
import Hotels from "./ReferenceInformation/Hotels";
import Bars from "./ReferenceInformation/Bars";
import Sanatoriums from "./ReferenceInformation/Sanatoriums";
import Museums from "./ReferenceInformation/Museums";
import AgriculturalManors from "./ReferenceInformation/AgriculturalManors";
import Operators from "./ReferenceInformation/Operators";
import Consulates from "./ReferenceInformation/Consulates";
import UsefulInformation from "./UsefulInformation";
import Standarts from "./UsefulInformation/Standarts";
import Cuts from "./UsefulInformation/Cuts";
import InvestmentProjects from "./InvestmentProjects";
import Gruszewka from "./InvestmentProjects/Gruszewka";
import RoadsideServiceStation from "./InvestmentProjects/RoadsideServiceStation";
import AutocampingBrest from "./InvestmentProjects/AutocampingBrest";
import Kudriczi from "./InvestmentProjects/Kudriczi";
import HuntingShack from "./InvestmentProjects/HuntingShack";
import InformationTouristPoint from "./InvestmentProjects/InformationTouristPoint";
import Maps from "./Maps";
import BrestStat from "./../src/Maps/BrestStat";
import BrestRegion from "./../src/Maps/BrestRegion";
import BrestTown from "./../src/Maps/BrestTown";
import BaranovicziRegion from "./../src/Maps/BaranovicziRegion";
import BaranovicziTown from "./../src/Maps/BaranovicziTown";
import BerezaRegion from "./../src/Maps/BerezaRegion";
import GancewicziRegion from "./Maps/GancewicziRegion";
import DrogiczinRegion from "./Maps/DrogiczinRegion";
import ZabinkaRegion from "./Maps/ZabinkaRegion";
import IvanovoRegion from "./Maps/IvanovoRegion";
import IvacewicziRegion from "./Maps/IvacewicziRegion";
import KamenecRegion from "./Maps/KamenecRegion";
import KobrinRegion from "./Maps/KobrinRegion";
import LuninecRegion from "./Maps/LuninecRegion";
import LiachovicziRegion from "./Maps/LiachovicziRegion";
import MaloritaRegion from "./Maps/MaloritaRegion";
import PinskRegion from "./Maps/PinskRegion";
import PinskTown from "./Maps/PinskTown";
import PruzanyRegion from "./Maps/PruzanyRegion";
import StolinRegion from "./Maps/StolinRegion";
import SEZ from "./Maps/SEZ";
import RepublicOfBelarus from "./Maps/RepublicOfBelarus";
import Europe from "./Maps/Europe";

function App() {
    return (
        <>
            <DocumentMeta {...META()} />

            <Header/>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Layout/>}>
                        <Route index element={<Home/>}/>
                        <Route path="/natural_resources" element={<NaturalResources/>}/>
                        <Route path="/exhibitions" element={<Exhibitions/>}/>
                        <Route path="/sport" element={<Sport/>}/>
                        <Route path="/culture" element={<Culture/>}/>

                        <Route path="/types_of_tourism" element={<TypesOfTourism/>}/>
                        <Route path="/auto_moto_tourism" element={<AutoMotoTourism/>}/>
                        <Route path="/cycling_tourism" element={<CyclingTourism/>}/>
                        <Route path="/domestic_tourism" element={<DomesticTourism/>}/>
                        <Route path="/water_tourism" element={<WaterTourism/>}/>
                        <Route path="/inbound_tourism" element={<InboundTourism/>}/>
                        <Route path="/outbound_tourism" element={<OutboundTourism/>}/>
                        <Route path="/business_tourism" element={<BusinessTourism/>}/>
                        <Route path="/disabled_tourism" element={<DisabledTourism/>}/>
                        <Route path="/commercial_tourism" element={<CommercialTourism/>}/>
                        <Route path="/equestrian_tourism" element={<EquestrianTourism/>}/>
                        <Route path="/cultural_tourism" element={<CulturalTourism/>}/>
                        <Route path="/medical_tourism" element={<MedicalTourism/>}/>
                        <Route path="/ski_tourism" element={<SkiTourism/>}/>
                        <Route path="/youth_tourism" element={<YouthTourism/>}/>
                        <Route path="/museum_tourism" element={<MuseumTourism/>}/>
                        <Route path="/scientific_tourism" element={<ScientificTourism/>}/>
                        <Route path="/nostalgic_tourism" element={<NostalgicTourism/>}/>
                        <Route path="/hunting_tourism" element={<HuntingTourism/>}/>
                        <Route path="/pilgrimage_tourism" element={<PilgrimageTourism/>}/>
                        <Route path="/hiking" element={<Hiking/>}/>
                        <Route path="/border_tourism" element={<BorderTourism/>}/>
                        <Route path="/adventure_tourism" element={<AdventureTourism/>}/>
                        <Route path="/recreational_tourism" element={<RecreationalTourism/>}/>
                        <Route path="/amateur_tourism" element={<AmateurTourism/>}/>
                        <Route path="/wedding_tourism" element={<WeddingTourism/>}/>
                        <Route path="/rural_tourism" element={<RuralTourism/>}/>
                        <Route path="/sports_tourism" element={<SportsTourism/>}/>
                        <Route path="/ecotourism" element={<Ecotourism/>}/>

                        <Route path="/virtual_tours" element={<VirtualTours/>}/>
                        <Route path="/vtur-beloe-ozero" element={<BeloeOzero/>}/>
                        <Route path="/vtur-mulnoie-ozero" element={<MulnoieOzero/>}/>
                        <Route path="/vtur-bel-puscha" element={<BelPuscha/>}/>
                        <Route path="/vtur-museum-locomotive" element={<MuseumLocomotive/>}/>
                        <Route path="/vtur-lelikovo-kort" element={<LelikovoKort/>}/>
                        <Route path="/vtur-land-of-kosciuszko" element={<LandOfKosciuszko/>}/>
                        <Route path="/vtur-bronnay-amountain" element={<BronnayaMountain/>}/>
                        <Route path="/vtur-andrey-tadeusz-kosciuszko" element={<AndreyTadeuszKosciuszko/>}/>
                        <Route path="/vtur-kosciuszko-memorial-sign" element={<KosciuszkoMemorialSign/>}/>
                        <Route path="/vtur-kosciuszko-opening-house" element={<KosciuszkoOpeningHouse/>}/>
                        <Route path="/vtur-kosciuszko-short-biography" element={<ShortBiography/>}/>
                        <Route path="/vtur-benzyaruk-pedigree-of-the-kostyushkas-of-siakhnowitz" element={<BenzyarukPedigreeOfTheKostyushkasOfSiakhnowitz/>}/>
                        <Route path="/vtur-nestsyarchuk-house-estate-of-tadeusz-kosciuszko" element={<NestsyarchukHouseEstateOfTadeuszKosciuszko/>}/>
                        <Route path="/vtur-benzyaruk-tadeusz-kosciuszko" element={<BenzyarukTadeuszKosciuszko/>}/>
                        <Route path="/vtur-benzyaruk-birth-of-kosciuszko" element={<BenzyarukBirthOfKosciuszko/>}/>
                        <Route path="/events" element={<Events/>}/>
                        <Route path="/event-opening-begin" element={<OpeningBegin/>}/>
                        <Route path="/event-brestchina-relax-2006" element={<BrestchinaRelax2006/>}/>
                        <Route path="/reference-information" element={<ReferenceInformation/>}/>
                        <Route path="/reference-information-hotels" element={<Hotels/>}/>
                        <Route path="/reference-information-hotels/:id" element={<Hotels/>}/>
                        <Route path="/reference-information-bars" element={<Bars/>}/>
                        <Route path="/reference-information-bars/:id" element={<Bars/>}/>
                        <Route path="/reference-information-sanatoriums" element={<Sanatoriums/>}/>
                        <Route path="/reference-information-sanatoriums/:id" element={<Sanatoriums/>}/>
                        <Route path="/reference-information-museums" element={<Museums/>}/>
                        <Route path="/reference-information-museums/:id" element={<Museums/>}/>
                        <Route path="/reference-information-agriculturalmanors" element={<AgriculturalManors/>}/>
                        <Route path="/reference-information-agriculturalmanors/:id" element={<AgriculturalManors/>}/>
                        <Route path="/reference-information-operators" element={<Operators/>}/>
                        <Route path="/reference-information-operators/:id" element={<Operators/>}/>
                        <Route path="/reference-information-consulates" element={<Consulates/>}/>
                        <Route path="/reference-information-consulates/:id" element={<Consulates/>}/>
                        <Route path="/useful-information" element={<UsefulInformation/>}/>
                        <Route path="/useful-information/standarts" element={<Standarts/>}/>
                        <Route path="/useful-information/cuts" element={<Cuts/>}/>
                        <Route path="/investment-projects" element={<InvestmentProjects/>}/>
                        <Route path="/investment-projects/gruszewka" element={<Gruszewka/>}/>
                        <Route path="/investment-projects/roadside-service-station" element={<RoadsideServiceStation/>}/>
                        <Route path="/investment-projects/autocamping-brest" element={<AutocampingBrest/>}/>
                        <Route path="/investment-projects/kudriczi" element={<Kudriczi/>}/>
                        <Route path="/investment-projects/hunting-shack" element={<HuntingShack/>}/>
                        <Route path="/investment-projects/information-tourist-point" element={<InformationTouristPoint/>}/>
                        <Route path="/maps" element={<Maps/>}/>
                        <Route path="/maps-bo" element={<BrestStat/>}/>
                        <Route path="/maps-brest-region" element={<BrestRegion/>}/>
                        <Route path="/maps-brest-town" element={<BrestTown/>}/>
                        <Route path="/maps-baranoviczi-region" element={<BaranovicziRegion/>}/>
                        <Route path="/maps-baranoviczi-town" element={<BaranovicziTown/>}/>
                        <Route path="/maps-bereza-region" element={<BerezaRegion/>}/>
                        <Route path="/maps-gancewiczi-region" element={<GancewicziRegion/>}/>
                        <Route path="/maps-drogiczin-region" element={<DrogiczinRegion/>}/>
                        <Route path="/maps-zabinka-region" element={<ZabinkaRegion/>}/>
                        <Route path="/maps-ivanovo-region" element={<IvanovoRegion/>}/>
                        <Route path="/maps-ivacewiczi-region" element={<IvacewicziRegion/>}/>
                        <Route path="/maps-kamenec-region" element={<KamenecRegion/>}/>
                        <Route path="/maps-kobrin-region" element={<KobrinRegion/>}/>
                        <Route path="/maps-luninec-region" element={<LuninecRegion/>}/>
                        <Route path="/maps-liachoviczi-region" element={<LiachovicziRegion/>}/>
                        <Route path="/maps-malorita-region" element={<MaloritaRegion/>}/>
                        <Route path="/maps-pinsk-region" element={<PinskRegion/>}/>
                        <Route path="/maps-pinsk-town" element={<PinskTown/>}/>
                        <Route path="/maps-pruzany-region" element={<PruzanyRegion/>}/>
                        <Route path="/maps-stolin-region" element={<StolinRegion/>}/>
                        <Route path="/maps-sez" element={<SEZ/>}/>
                        <Route path="/maps-republicofbelarus" element={<RepublicOfBelarus/>}/>
                        <Route path="/maps-europe" element={<Europe/>}/>

                        <Route path="/topic-melittis-sarmatica" element={<MelittisSarmatica/>}/>
                        <Route path="/topic-hedera" element={<Hedera/>}/>
                        <Route path="/topic-nashaniwa-belpuscha-1908" element={<NashaNiwaBelPuscha/>}/>
                        <Route path="/topic-locomotive-EU699-45" element={<LocomotiveEU699_45/>}/>
                        <Route path="/topic-locomotive-ER770-36" element={<LocomotiveER770_36/>}/>
                        <Route path="/topic-locomotive-ER17-750-01" element={<LocomotiveER17_750_01/>}/>
                        <Route path="/topic-locomotive-TE8026" element={<LocomotiveTE8026/>}/>
                        <Route path="/topic-locomotive-TE074" element={<LocomotiveTE074/>}/>
                        <Route path="/topic-locomotive-TE2596" element={<LocomotiveTE2596/>}/>
                        <Route path="/topic-locomotive-TE5806" element={<LocomotiveTE5806/>}/>
                        <Route path="/topic-locomotive-CO17-3268" element={<LocomotiveCO17_3268/>}/>
                        <Route path="/topic-locomotive-L0009" element={<LocomotiveL0009/>}/>
                        <Route path="/topic-locomotive-L1259" element={<LocomotiveL1259/>}/>
                        <Route path="/topic-locomotive-tank-9P" element={<LocomotiveTank9P/>}/>
                        <Route path="/topic-locomotive-TE1-20-165" element={<LocomotiveTE1_20_165/>}/>
                        <Route path="/topic-locomotive-TEP60-0121" element={<LocomotiveTEP60_0121/>}/>
                        <Route path="/topic-locomotive-CME2-209" element={<LocomotiveCME2_209/>}/>
                        <Route path="/topic-locomotive-TEZ-6965" element={<LocomotiveTEZ_6965/>}/>
                        <Route path="/topic-locomotive-TEM15-017" element={<LocomotiveTEM15_017/>}/>
                        <Route path="/topic-locomotive-2TEM109-002" element={<Locomotive2TEM109_002/>}/>
                        <Route path="/topic-locomotive-M62-1003" element={<LocomotiveM62_1003/>}/>
                        <Route path="/topic-locomotive-cranes" element={<LocomotiveCranes/>}/>
                        <Route path="/topic-locomotive-wagons" element={<Wagons/>}/>
                        <Route path="/topic-locomotive-platform" element={<Platform/>}/>
                        <Route path="/topic-locomotive-cisterns" element={<Cisterns/>}/>

                    </Route>
                </Routes>
            </BrowserRouter>
            <Footer/>
        </>
    );
}

export default App;
